export * from './kunden-arts.page';
export * from './kunden-arts.page.resolver';
